import type { WeaponId } from "@frontier/content/definitions";

export interface ProjectileAppearance {
  texture: "pulse" | "laser" | "missile" | "mine" | "plasma";
  length: number;
  tint: number;
}
const appearances: Record<WeaponId | "mine", ProjectileAppearance> = {
  pulse: { texture: "pulse", length: 30, tint: 0xffc09c },
  laser: { texture: "laser", length: 90, tint: 0xff7777 },
  missile: { texture: "missile", length: 36, tint: 0xffffff },
  flak: { texture: "pulse", length: 17, tint: 0xffe17a },
  rail: { texture: "laser", length: 54, tint: 0xf3b5ff },
  ion: { texture: "plasma", length: 50, tint: 0x8effff },
  mine: { texture: "mine", length: 28, tint: 0xffffff },
};

export function projectileAppearance(kind: string): ProjectileAppearance {
  switch (kind) {
    case "pulse":
    case "laser":
    case "missile":
    case "flak":
    case "rail":
    case "ion":
    case "mine":
      return appearances[kind];
    default:
      return appearances.pulse;
  }
}
